import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';

const initialState = {
  levelIndex: 0,
  itemIndex: 0, // the index in the current level's "items" array to pull content from.
  selectedCuriosoIndex: 0, // the index in the curioso arrays to pull assets from.
  // the inference types that a user has heard a specific praise VO for.
  // after a user hears specific praise for a certain type of inference, they'll just hear the less verbose generic praise every time after that.
  hasRecievedPraiseFor: [],
  contentSidesByLevel: [],
};

const curriculumReducer = (state = initialState, { type, gameId, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_LEVEL_INDEX: {
      const contentSidesByLevel = [...state.contentSidesByLevel];
      const { levelIndex, contentSide } = payload;
      contentSidesByLevel[levelIndex] = contentSide;

      return {
        ...state,
        levelIndex: payload.levelIndex,
        contentSidesByLevel,
      };
    }

    case REDUX_ACTIONS.SET_HAS_HEARD_SPECIFIC_PRAISE:
      return {
        ...state,
        hasRecievedPraiseFor: [...state.hasRecievedPraiseFor, payload],
      };

    /**
     * On the 'daytime' levels, curioso assets / indices are numbered 0-4,
     * which lines up perfectly with the content array we have in curriculum.json.
     * On the 'nighttime' levels, the curioso assets / indices are numbered 5-9,
     * which doesn't map to anything in a content array.
     * So running a %5 reduces the values of those nighttime curiosos
     * so they can map cleanly to an index in the content array.
     *
     * ( We need to also keep the curioso value from 0-9 because it is what we use
     * to reference the correct SVGs for the curiosos when they're on the map,
     * as well as the SVG for their shadow asset on the standard item screen. )
     */
    case REDUX_ACTIONS.SELECT_CURIOSO: {
      const index = payload % 5;
      return {
        ...state,
        itemIndex: index,
        selectedCuriosoIndex: payload,
      };
    }

    default:
      return state;
  }
};

export default curriculumReducer;
